"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdFileSize;
(function (AdFileSize) {
    AdFileSize["small"] = "small";
    AdFileSize["medium"] = "medium";
    AdFileSize["large"] = "large";
    AdFileSize["xLarge"] = "xLarge";
    AdFileSize["square"] = "square";
    AdFileSize["banner"] = "banner";
    AdFileSize["long"] = "long";
})(AdFileSize = exports.AdFileSize || (exports.AdFileSize = {}));
var AdFileFormats;
(function (AdFileFormats) {
    AdFileFormats["jpg"] = "jpg";
    AdFileFormats["jpeg"] = "jpeg";
    AdFileFormats["png"] = "png";
})(AdFileFormats = exports.AdFileFormats || (exports.AdFileFormats = {}));
//# sourceMappingURL=adFile.js.map